<template>
  <iColumn>
    <iText v-if="!activeAppId">
      Select an app to start.
    </iText>
    <iColumn v-else>
      <ProfileWrapper
        :splash-image="appSplashImage"
        :logo-image="appLogo"
        :title="appName"
        :details="appDescription"
      >
        <template #menu>
          <iLink :href="activeAppUrl">
            <iButton size="small">
              Edit App
            </iButton>
          </iLink>
        </template>
      </ProfileWrapper>
    </iColumn>
  </iColumn>
</template>

<script>
import { mapState } from "pinia";
import { useCreateStore } from "@/stores/create-store";
import ProfileWrapper from "@/components/publication/ProfileWrapper.vue";
import { DEFAULT_ORG_LOGO, DEFAULT_SPLASH_IMAGE } from "%/constants/publication-constants";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "AppDetails",
  components: { ProfileWrapper },
  props: {
    activeAppId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    ...mapState(useCreateStore, [
      "dynamicApps",
    ]),
    activeApp() {
      if (!this.activeAppId) {
        return {};
      }
      return this.dynamicApps[this.activeAppId] ?? {};
    },
    activeAppUrl() {
      return `${useGeneralStore().links.web}/develop/app/${this.activeAppId}`;
    },
    appLogo() {
      return DEFAULT_ORG_LOGO;
    },
    appSplashImage() {
      return DEFAULT_SPLASH_IMAGE;
    },
    appName() {
      return this.activeApp.configuration.title;
    },
    appDescription() {
      return this.activeApp.configuration.description ?? "";
    },
  },
};
</script>

<style scoped lang="scss">

</style>
